import { render, staticRenderFns } from "./WechartAccount.vue?vue&type=template&id=23952712&scoped=true&"
import script from "./WechartAccount.vue?vue&type=script&lang=js&"
export * from "./WechartAccount.vue?vue&type=script&lang=js&"
import style0 from "./WechartAccount.vue?vue&type=style&index=0&id=23952712&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23952712",
  null
  
)

export default component.exports